import React, { useEffect, useCallback } from 'react';
import styles from 'feature/login-flow/index.module.sass';
import Button from 'components/button';
import OnBoardingLayout from 'layout/onboarding';
import {
  SET_ACTIVATED_LICENSE_PLATES,
  useLoginFlowContext,
  SET_ACTIVATE_LICENSE_PLATES_DIALOG,
} from 'feature/login-flow/use-login-flow';
import { useAppContext } from 'use-app';
import amplitude from 'service/amplitude';
import Checkbox from 'components/checkbox';
import Card from 'components/card';
import ButtonDialog from 'components/button-dialog';

const ActivateLicensePlates = () => {
  const { state: appState } = useAppContext();
  const { state, dispatch, fetchExistLicensePlates, deactivatePlates } = useLoginFlowContext();

  useEffect(() => {
    if (!appState.licensePlatesIsSetted) {
      fetchExistLicensePlates();
    }
  }, [appState.licensePlatesIsSetted]); //eslint-disable-line

  useEffect(() => {
    if (state.activateLicensePlatesDialog) {
      amplitude.activated_dialog_pageview();
    }
  }, [state.activateLicensePlatesDialog]);

  const selectPlateNumber = plateNumber => {
    if (state.activatedLicensePlates.indexOf(plateNumber) !== -1) {
      let result = () => {
        let arr = state.activatedLicensePlates;
        arr.splice(arr.indexOf(plateNumber), 1);
        return arr;
      };
      dispatch({ type: SET_ACTIVATED_LICENSE_PLATES, payload: result() });
    } else {
      dispatch({
        type: SET_ACTIVATED_LICENSE_PLATES,
        payload: state.activatedLicensePlates.concat(plateNumber),
      });
    }
  };

  const onConfirmPlateNumber = useCallback(() => {
    deactivatePlates(state.activatedLicensePlates);
  }, [state.activatedLicensePlates]); //eslint-disable-line

  const onDismissDialog = () => {
    amplitude.activated_dialog_back_onClick();
    dispatch({ type: SET_ACTIVATE_LICENSE_PLATES_DIALOG, payload: false });
  };

  return (
    <>
      <ButtonDialog
        isShow={state.activateLicensePlatesDialog}
        title="請選擇一張車牌繼續"
        items={[
          {
            theme: 'positive',
            content: '返回',
            onClick: onDismissDialog,
          },
        ]}
      >
        請至少選擇一張車牌啟用付款功能，才能繼續。
      </ButtonDialog>

      <OnBoardingLayout className={styles['activate-license-plates']}>
        <div className={styles.top}>
          <ul className={styles.progress}>
            <li className={styles.active}>1</li>
            <li className={styles.active}>2</li>
            <li>3</li>
          </ul>
          <div className={styles.title}>啟用付款車牌</div>
          <div className={styles.desc}>
            前往支援麻吉付地點時，將自動辨識您的車牌，將車牌作為您的付款通行證，付款更快速。
          </div>
          {appState.licensePlates.map(licensePlate => {
            const isChecked = state.activatedLicensePlates.indexOf(licensePlate.plateNumber) !== -1;
            return (
              <Card onClick={() => selectPlateNumber(licensePlate.plateNumber)} className={styles.plate}>
                {licensePlate.plateNumber}
                <Checkbox
                  style={{ pointerEvents: 'none' }}
                  id={licensePlate.id}
                  name={isChecked ? '啟用' : '選擇'}
                  isChecked={isChecked}
                  onCheckChanged={() => {}}
                />
              </Card>
            );
          })}
        </div>
        <div className={styles.bottom}>
          <Button theme="blue" block={true} loading={state.loading} onClick={onConfirmPlateNumber}>
            確定啟用
          </Button>
        </div>
      </OnBoardingLayout>
    </>
  );
};

export default ActivateLicensePlates;
